export const init = () => {};
